import { FuseNavigation } from 'src/@fuse/types';

export const navigationBeforeReg: FuseNavigation[] = [
  {
    id: 'applications',
    title: 'APLICACIONES',
    type: 'group',
    translate: '',
    icon: '',
    url: '',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARD.TITLE',
        type: 'item',
        icon: 'home',
        url: '/dashboard',
      },
      {
        id: 'contactos',
        title: 'Contactos',
        type: 'item',
        icon: 'home',
        url: '/home',
        translate: '',
      },
      {
        id: 'agenda',
        title: 'Agenda',
        type: 'item',
        icon: 'home',
        url: '/agenda',
        translate: '',
      },
      {
        id: 'chat',
        title: 'Chat',
        type: 'item',
        icon: 'home',
        url: '/chat',
        translate: '',
      },
      {
        id: 'curriculum',
        title: 'Curriculum',
        type: 'item',
        icon: 'home',
        url: '/curriculum',
        translate: '',
      },
      {
        id: 'email',
        title: 'Email',
        type: 'item',
        icon: 'home',
        url: '/email',
        translate: '',
      },
      {
        id: 'archivos',
        title: 'Archivos',
        type: 'item',
        icon: 'home',
        url: '/archivos',
        translate: '',
      },
    ],
  },
];
